
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { CategoryForm } from "./CategoryForm"
import type { Database } from "@/integrations/supabase/types"

type ClientCategory = Database["public"]["Tables"]["client_categories"]["Row"]

interface ExistingCategoryCardProps {
  category: ClientCategory
  onSave: () => void
}

export function ExistingCategoryCard({ category, onSave }: ExistingCategoryCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{category.name}</CardTitle>
        {category.description && (
          <CardDescription>{category.description}</CardDescription>
        )}
      </CardHeader>
      <CardContent>
        <CategoryForm 
          category={category}
          formId={`category-form-${category.id}`}
          onSave={onSave}
        />
      </CardContent>
    </Card>
  )
}
